export const NAME = "itemExplorer"
export const ItemTypes = {
  ITEM_VIEW: `${NAME}/ITEM_VIEW`,
  CATEGORY_VIEW: `${NAME}/CATEGORY_VIEW`,
}
export const PreviewTypes = {
  ITEM_PREVIEW: `${NAME}/ITEM_PREVIEW`,
  EVENT_PREVIEW: `${NAME}/EVENT_PREVIEW`,
}
